/**
 * Copyright 2025 SweetCode. All rights reserved.
 *
 * Load Twitter Ads functions
 * */

(function (pmw, undefined) {

	pmw.loadTwitterPixel = () => {

		try {

			// @formatter:off
			!function(e,t,n,s,u,a){e.twq||(s=e.twq=function(){s.exe?s.exe.apply(s,arguments):s.queue.push(arguments);
			},s.version='1.1',s.queue=[],u=t.createElement(n),u.async=!0,u.src='https://static.ads-twitter.com/uwt.js',
				a=t.getElementsByTagName(n)[0],a.parentNode.insertBefore(u,a))}(window,document,'script');

			twq('config',pmwDataLayer.pixels.twitter.pixel_id);
			// @formatter:on

			// twq("track", "PageView")

			pmwDataLayer.pixels.twitter.loaded = true
		} catch (e) {
			console.error(e)
		}
	}

	pmw.twitterGetOrderContentIdsV1 = () => {
		let contentIds = []

		Object.values(pmwDataLayer.order.items).forEach(item => {

			const productId = pmwDataLayer?.shop?.variations_output && 0 !== item.variation_id ? item.variation_id : item.id
			const product   = pmw.getDataLayerProduct(productId)

			// A product deleted since the order was placed has no data left to
			// report. Skip the line rather than lose the whole conversion.
			if (!product) {
				pmw.console.warn("X (Twitter): skipped an order item without product data: " + productId)
				return
			}

			contentIds.push(String(product.dyn_r_ids[pmwDataLayer.pixels.twitter.dynamic_remarketing.id_type]))
		})

		return contentIds
	}

	pmw.twitterGetOrderContentIdsV2 = () => {

		let orderItems = []

		Object.values(pmwDataLayer.order.items).forEach(item => {

			const productId = pmwDataLayer?.shop?.variations_output && 0 !== item.variation_id ? item.variation_id : item.id
			const product   = pmw.getDataLayerProduct(productId)

			// A product deleted since the order was placed has no data left to
			// report. Skip the line rather than lose the whole conversion.
			if (!product) {
				pmw.console.warn("X (Twitter): skipped an order item without product data: " + productId)
				return
			}

			orderItems.push({
				content_type : "product",
				content_name : item.name,
				content_price: item.price,
				num_items    : item.quantity,
				// content_group_id: null,
				content_id   : product.dyn_r_ids[pmwDataLayer.pixels.twitter.dynamic_remarketing.id_type],
			})
		})

		return orderItems
	}

	/**
	 * Can fire Twitter event
	 *
	 * @return {boolean}
	 */
	pmw.canFireTwitterEvent = () => {
		if (!pmwDataLayer?.pixels?.twitter?.loaded) return false

		if(!pmw.consent.categories.get().marketing) return false

		return true
	}

	/**
	 * Can not fire Twitter event
	 *
	 * @return {boolean}
	 */
	pmw.canNotFireTwitterEvent = () => {
		return !pmw.canFireTwitterEvent()
	}

}(window.pmw = window.pmw || {}));
